// @flow
export const hasPermission = (permissionKey, permissionsArray) =>
    permissionsArray
        ? permissionsArray.some(
              (permissionItem) => permissionItem.key === permissionKey && permissionItem.havePermission,
          )
        : false;

export const hasPermissionArray = (permissionKeys, permissionsArray) =>
    permissionKeys && permissionsArray
        ? permissionKeys.some((permissionKey) => hasPermission(permissionKey, permissionsArray))
        : false;

export const isBase64 = (str: string) => {
    try {
        return btoa(atob(str)) === str;
    } catch (ex) {
        return false;
    }
};

export const resolveHashParams = (location: string, pathPropertyName = 'path'): URLSearchParams => {
    const url = new URL(location);
    const hash = url.hash.substring(1); // Remove '#' and creates parameters
    // Check for Base64 compatibility
    if (hash.length && isBase64(hash)) {
        const decodedHash = atob(hash);
        return new URLSearchParams({ [pathPropertyName]: decodedHash });
    }
    return new URLSearchParams(hash);
};

export const parseHashParams = async (getLocation?: any): Promise<URLSearchParams> => {
    if (getLocation) {
        // Accessing in a Jira environment (via iframe)...
        return new Promise((resolve) => {
            getLocation((location: string) => {
                resolve(resolveHashParams(location));
            });
        });
    }

    return resolveHashParams(window.location.href);
};
